import { Button, Col, Row } from "antd";
import React from "react";
import SliderComponent from "./SliderComponent";
import { ReactComponent as ArrowRight } from "../../../../assets/images/icon/backToTop.svg";
const Blog: React.FC<any> = () => {
    return (
        <>
            <section className="section blogSection" id="blog" style={{ display: "none" }}>
                <div className="blogContainer">
                    <Row>
                        <Col span={10} className="marginCol">
                            <div className="blogContent">
                                <h3>Latest Blog</h3>
                                <p>Know more latest announcement about App Lorem ipsum dolor sit amet,
                                    consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                <div className="blogBtn">
                                    <Button className="commanBtn">

                                        <span className="arrowIcon">
                                            <ArrowRight />
                                        </span>
                                        <span className="beforeIcon"></span>
                                        <span>Read More</span>
                                    </Button>
                                </div>
                            </div>
                        </Col>
                        <Col span={14}>
                            <SliderComponent />
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default Blog;
